var map = {
	"./": [
		"Hs3B",
		"chunk-1625"
	],
	"./api": [
		"rFyC",
		"rFyC"
	],
	"./api.js": [
		"rFyC",
		"rFyC"
	],
	"./index": [
		"Hs3B",
		"chunk-1625"
	],
	"./index.vue": [
		"Hs3B",
		"chunk-1625"
	],
	"./indexNew": [
		"GaPv",
		"chunk-09f1"
	],
	"./indexNew.vue": [
		"GaPv",
		"chunk-09f1"
	],
	"./routes": [
		"Mcjb"
	],
	"./routes.js": [
		"Mcjb"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "AaMY";
module.exports = webpackAsyncContext;